import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidBumiKiaraPayungSlider from "./slider/MasjidBumiKiaraPayungSlider";
import Footer from "../../../../../../Footer";

export default function MasjidBumiKiaraPayung() {

  return (
    <div className="modal-img">
        <MasjidBumiKiaraPayungSlider/>
        <Footer/>
    </div>
  );
}